import { useEffect, useState } from 'react';
import { getBalance } from '../../services/ExchangeService';
import { Link } from 'react-router-dom';

function DashboardWalletCard(props) {
    const [balances, setBalances] = useState([]);
    const [fiat, setFiat] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isFuture, setIsFuture] = useState(props.isFuture || false);
    const [refreshHours, setRefreshHours] = useState(1);

    function getBalanceCall() {
        getBalance(isFuture)
            .then((info) => {
                if (!info || typeof info !== 'object') {
                    setBalances([]);
                    setFiat('');
                    setIsLoading(false);
                    return;
                }

                const balances = Object.entries(info)
                    .filter(([, value]) => value && typeof value === 'object' && value.available !== undefined)
                    .map(([symbol, data]) => ({
                        symbol,
                        available: data.available,
                        onOrder: data.onOrder
                    }))
                    .sort((a, b) => {
                        if (a.symbol > b.symbol) return 1;
                        if (a.symbol < b.symbol) return -1;
                        return 0;
                    })
                    .filter(b => parseFloat(b.available) > 0 || parseFloat(b.onOrder) > 0)
                    .slice(0, 10); // Limita a 10 itens

                if (props.onUpdate)
                    props.onUpdate(balances);

                setBalances(balances);
                setFiat(info.fiatEstimate);
                if (Number(info.walletRefreshHours) > 0)
                    setRefreshHours(Number(info.walletRefreshHours));
                setIsLoading(false);
            })
            .catch(err => {
                console.error(err.response ? err.response.data : err.message);
                setIsLoading(false);
            })
    }

    useEffect(() => {
        setIsLoading(true);
        if (props.data && Object.entries(props.data).length) {
            const balances = (Array.isArray(props.data) ? props.data : Object.entries(props.data)
                .filter(([key, value]) => key !== 'fiatEstimate' && value && typeof value === 'object')
                .map(([symbol, data]) => ({
                    symbol,
                    available: data.available,
                    onOrder: data.onOrder
                })))
                .filter(b => parseFloat(b.available) > 0 || parseFloat(b.onOrder) > 0)
                .slice(0, 10);
            setBalances(balances);
            setIsLoading(false);
        }
        else
            getBalanceCall();

    }, [props.data, isFuture])

    useEffect(() => {
        if (props.data && Object.entries(props.data).length) return undefined;
        const ms = Math.max(1, Number(refreshHours) || 1) * 60 * 60 * 1000;
        const timer = setInterval(() => {
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            getBalanceCall();
        }, ms);
        return () => clearInterval(timer);
    }, [props.data, isFuture, refreshHours])

    function formatNumber(num) {
        if (!num || num === '0') return '-';
        return parseFloat(num).toFixed(8).substring(0, 10);
    }

    return (
        <div className="dashboard-card">
            <div className="dashboard-card-header">
                <h3 className="dashboard-card-title">Carteira</h3>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    {localStorage.getItem("hasFutures") === 'true' && (
                        <button 
                            className='btn btn-sm' 
                            onClick={() => setIsFuture(!isFuture)}
                            style={{
                                background: isFuture ? 'rgba(140, 102, 252, 0.2)' : 'rgba(37, 37, 37, 0.8)',
                                border: '1px solid rgba(140, 102, 252, 0.3)',
                                color: '#e0e0e0',
                                borderRadius: '8px',
                                padding: '5px 12px',
                                fontSize: '0.85rem'
                            }}
                        >
                            {isFuture ? "Futuros" : "Spot"}
                        </button>
                    )}
                    <Link 
                        to="/wallet" 
                        style={{
                            background: 'linear-gradient(90deg, #8c66fc 0%, #0274d8 100%)',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '5px 12px',
                            color: 'white',
                            textDecoration: 'none',
                            fontSize: '0.85rem',
                            fontWeight: 600
                        }}
                    >
                        Ver Tudo
                    </Link>
                </div>
            </div>
            <div className="dashboard-card-content">
                {!isLoading && balances && balances.length > 0 ? (
                    <>
                        {balances.map(item => (
                            <div key={`wallet${item.symbol}`} className="dashboard-card-item">
                                <div className="dashboard-card-item-symbol">{item.symbol}</div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px' }}>
                                    <div className="dashboard-card-item-value">
                                        <span className="dashboard-card-item-label">Disponível:</span>
                                        {formatNumber(item.available)}
                                    </div>
                                    {parseFloat(item.onOrder) > 0 && (
                                        <div className="dashboard-card-item-value" style={{ fontSize: '0.8rem', color: '#a0a0a0' }}>
                                            <span className="dashboard-card-item-label">Bloqueado:</span>
                                            {formatNumber(item.onOrder)}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                        {fiat && (
                            <div style={{ 
                                marginTop: '15px', 
                                paddingTop: '15px', 
                                borderTop: '1px solid rgba(140, 102, 252, 0.2)',
                                textAlign: 'center'
                            }}>
                                <div style={{ fontSize: '0.85rem', color: '#a0a0a0', marginBottom: '5px' }}>Total Estimado</div>
                                <div style={{ 
                                    fontSize: '1.2rem', 
                                    fontWeight: 700,
                                    background: 'linear-gradient(90deg, #8c66fc 0%, #0274d8 100%)',
                                    WebkitBackgroundClip: 'text',
                                    backgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent'
                                }}>
                                    {fiat}
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="dashboard-card-empty">Carregando...</div>
                )}
            </div>
        </div>
    );
}

export default DashboardWalletCard;














